import * as ethers from 'ethers'

export const ethToWei = (eth: string): string => {
  return ethers.utils.parseEther(eth).toString()
}
